import List from '@mui/material/List';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { GetChangeDto } from '@codefluegel/zeta-change-typescript-client';
import { GridLegacy, ListItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const DateViewDialog = observer(
  ({
    onClose,
    open,
    change,
    project,
  }: {
    onClose: () => void;
    open: boolean;
    change: GetChangeDto | undefined;
    project: string;
  }) => {
    const { t } = useTranslation();

    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ minWidth: 500 }}
      >
        <DialogTitle
          sx={{ fontSize: 14 }}
        >{`Projekt ${project} - TERMINE`}</DialogTitle>

        <IconButton
          sx={{ position: 'absolute', right: 5, top: 5 }}
          color="primary"
          component="span"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        {change ? (
          <List>
            <ListItem alignItems="flex-start">
              <GridLegacy container>
                <GridLegacy sx={{ minWidth: 250, fontWeight: 'bold' }} item>
                  vom Kunden angenommen am:{' '}
                </GridLegacy>
                <GridLegacy item>
                  {change.approvalDateClient &&
                    new Date(change.approvalDateClient).toLocaleDateString()}
                </GridLegacy>
              </GridLegacy>
            </ListItem>
            <ListItem alignItems="flex-start">
              <GridLegacy container>
                <GridLegacy sx={{ minWidth: 250, fontWeight: 'bold' }} item>
                  Intern angenommen am:{' '}
                </GridLegacy>
                <GridLegacy item>
                  {change.internalApprovalDate &&
                    new Date(change.internalApprovalDate).toLocaleDateString()}
                </GridLegacy>
              </GridLegacy>
            </ListItem>
            <ListItem alignItems="flex-start">
              <GridLegacy container>
                <GridLegacy sx={{ minWidth: 250, fontWeight: 'bold' }} item>
                  {t('dates.evalDate')}
                </GridLegacy>
                <GridLegacy item>
                  {change.evaluationTargetDate &&
                    new Date(change.evaluationTargetDate).toLocaleDateString()}
                </GridLegacy>
              </GridLegacy>
            </ListItem>
            <ListItem alignItems="flex-start">
              <GridLegacy container>
                <GridLegacy sx={{ minWidth: 250, fontWeight: 'bold' }} item>
                  zu implementiern bis:{' '}
                </GridLegacy>
                <GridLegacy item>
                  {change.implementationTargetDate &&
                    new Date(
                      change.implementationTargetDate,
                    ).toLocaleDateString()}
                </GridLegacy>
              </GridLegacy>
            </ListItem>
          </List>
        ) : (
          <p>no data</p>
        )}
      </Dialog>
    );
  },
);

export default DateViewDialog;
